var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conOfBreadcrumbs"},[_c('v-breadcrumbs',{attrs:{"items":_vm.BreadcrumbList},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }